export let avatarImageString: string;
export let profileName: string;
export let headerText: string;
export let stopCodes: boolean | undefined;
export let regModal: boolean | undefined;
export let company_Name: string;
export let company_Address: string;
export let company_Phone: string;
export let companyDir: string;
export let branch: string;

export const getData = (avImgString: string, firstName: string, lastName: string ) => {
avatarImageString = avImgString;
const fName = firstName.length > 1 ? firstName.charAt(0).toUpperCase() + firstName.slice(1) : firstName.charAt(0).toUpperCase();
const lName = lastName.length > 2 ? lastName.charAt(0).toUpperCase() + lastName.slice(1) : lastName.charAt(0).toUpperCase();
profileName = fName + ' ' + lName;
}

export const getCompanyData = (name: string, address: string, phone: string) => {
    company_Name = name;
    company_Address = address;
    company_Phone = phone;
}

export const header = (text: string) => {
    headerText = text;
}

export const stopExecutions= (bool: boolean | undefined) => {
   stopCodes = bool
}

export const registerModal = (value: boolean) => {
    regModal = value
}

export const handleCompanyDir = (value: string) => {
    companyDir = value
}

export const handleBranch = (value: string) => {
    branch = value
}

